import type { TOC } from '@ember/component/template-only'
import { ChartsWorkingAtGradeLevelTotals } from 'district-ui-client/components/charts/working-at-grade-level/totals/component'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { not } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import fullGradeName from 'district-ui-client/helpers/full-grade-name'
import type ReportingReWorkingAtGradeLevelRoute from 'district-ui-client/reporting/ui-scope/re/working-at-grade-level/route'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<ReportingReWorkingAtGradeLevelRoute>
  }
}

export const ReWorkingAtGradeLevelRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.workingAtGradeLevel}}>
    {{#each @model.workingAtGradeLevel as |gradeData|}}
      <div class="detailed-chart-wrapper">
        <ChartsWorkingAtGradeLevelTotals
          class="h-60"
          @data={{gradeData}}
          @product={{@model.product}}
          @grade={{fullGradeName gradeData.grade_position}}
          @tooltip={{t "reporting.tooltips.workingAtGradeLevel"}}
        />
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(ReWorkingAtGradeLevelRouteTemplate)
